import React from "react"
import Trends from "./Trends"

const Dashboard = () => {
  document.title = "Trends | AGRA"

  return (
    <div className="page-content">
      <Trends/>
    </div>
  )
}

export default Dashboard
